import "./GridFw.css";
import React from "react";
import log from "loglevel";
import { Input, Row, Spin, Table } from "antd";
import CreateColumn from "./helpers/createColumn";
import { ICON } from "../../constants/iconConstants";
import { GridApi } from "./GridApi";
import { EditableCell } from "./editable/EditableCell";
import ContainerFw from "../container/ContainerFw";
import { EditableRow } from "./editable/EditableRow";
import { useState } from "react";
import Search from "antd/lib/input/Search";
import Col from "antd/es/grid/col";
import Icon from "@ant-design/icons";

export const COLUMN_DEFAULT = {
  VIEW: { name: "view", type: "button", icon: ICON.VIEW },
  DELETE: {
    name: "delete",
    type: "button",
    icon: ICON.DELETE,
    confirm: {
      title: "Eliminación",
      message: "¿Esta seguro que desea eliminar el registro?",
    },
  },
  EDIT: { name: "edit", type: "button", icon: ICON.EDIT },
  REPORT: { name: "report", type: "button", icon: ICON.REPORT },
  MAIL: { name: "mail", type: "button", icon: ICON.MAIL },
  DROPBOX: { name: "dropbox", type: "button", icon: ICON.DROPBOX },
  OPTIONS: { name: "unorderedList", type: "button", icon: ICON.OPTION },
  EXCEL: { name: "excel", type: "button", icon: ICON.EXCEL },
  SETTING: { name: "setting", type: "button", icon: ICON.SETTING },
  ORDER: { name: "order", type: "button", icon: ICON.ORDER },
  ADD: { name: "add", type: "button", icon: ICON.PLUS },
  COPY: { name: "copy", type: "button", icon: ICON.COPY },
  PDF: { name: "pdf", type: "button", icon: ICON.PDF },
  CHECK: { name: "check", type: "button", icon: ICON.CHECK },
  CANCEL: { name: "cancel", type: "button", icon: ICON.CANCEL },
  EYE: { name: "eye", type: "button", icon: ICON.EYE },
  DOWNLOAD: { name: "download", type: "button", icon: ICON.DOWNLOAD },
  EXPERIMENT: { name: "experiment", type: "button", icon: ICON.EXPERIMENT },
  DOCUMENT: { name: "document", type: "button", icon: ICON.NEW },
  SYNC: { name: "sync", type: "button", icon: ICON.SYNC },
  COMMENT: { name: "comment", type: "button", icon: ICON.COMMENT },
  ADD_SQUARE: { name: "add_square", type: "button", icon: ICON.ADD_SQUARE },
};

export const SELECTION_TYPE = {
  MULTIPLE: "checkbox",
  SINGLE: "radio",
};

const CreateGrid = (name, config, state, handleTableChange, getApi) => {
  const components = !getApi().isEditable()
    ? null
    : {
        body: {
          row: EditableRow,
          cell: EditableCell,
        },
      };
  // const [filterInput, setFilterInput] = useState('')
  const [dataSource, setDataSource] = useState(state?.dataList);

  const [value, setValue] = useState("");

  const filterData = (currValue) => {
    if (currValue === "") {
      //setValue({value: ''});
      return state.dataList;
    } else {
      if (state.dataList) {
        let arrayOfMatchedObjects = state.dataList.filter((object) => {
          return JSON.stringify(object)
            .toString()
            .toLowerCase()
            .includes(currValue.toLowerCase());
        });
        return arrayOfMatchedObjects;
      } else {
        //setValue({value: ''});
        return state.dataList;
      }
    }
  };

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [loadingRows, setLoadingRows] = useState({});

  const getRowKey = (record, index) => record.key || record.id || record.ID || index;

  const handleExpand = async (expanded, record, index) => {
    const key = getRowKey(record, index);

    if (expanded) {
      if (expandedRows[key]) {
        setExpandedKeys((prev) => [...prev, key]);
        return;
      }

      setLoadingRows((prev) => ({ ...prev, [key]: true }));

      try {
        const result = config.expandableAsync(record);
        const resolved = result instanceof Promise ? await result : result;
        setExpandedRows((prev) => ({ ...prev, [key]: resolved }));
      } catch (err) {
        console.error("Error en expandable:", err);
        setExpandedRows((prev) => ({
          ...prev,
          [key]: <div style={{ color: "red" }}>Error al cargar datos</div>,
        }));
      } finally {
        setLoadingRows((prev) => ({ ...prev, [key]: false }));
        setExpandedKeys((prev) => [...prev, key]);
      }
    } else {
      setExpandedKeys((prev) => prev.filter((k) => k !== key));
    }
  };

  // const onSelectChange = selectedRowKeys => {
  //     console.log('selectedRowKeys changed: ', selectedRowKeys);
  //     setSelected({ selectedRowKeys });
  // };

  // const rowSelection = {
  //     selectedRowKeys,
  //     onChange: onSelectChange,
  // };

  // const rowSelection = {
  //     onChange: (selectedRowKeys, selectedRows) => {
  //       console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  //     },
  //     getCheckboxProps: (record) => ({
  //       disabled: record.name === 'Disabled User',
  //       // Column configuration not to be checked
  //       name: record.name,
  //     }),
  //   };

  const expandableAsync = config.expandableAsync && {
    expandedRowRender: (record, index) => {
      const key = getRowKey(record, index);
      const isLoading = loadingRows[key];
      const content = expandedRows[key];
        return (
          <div>
            <Spin spinning={!!isLoading}>
              {content || (!isLoading && <div>No hay datos disponibles</div>)}
            </Spin>
          </div>
        );
    },
    expandedRowKeys: expandedKeys,
    onExpand: handleExpand,
    expandIcon: ({ expanded, onExpand, record }) => (
      <div
        onClick={(e) => onExpand(record, e)}
        style={{ cursor: 'pointer', width: 'max-content', color: '#1890ff' }}
      >
        <span>{expanded ? 'Ocultar' : 'Ver detalle'}</span>
        {expanded ? ICON.DOWN : ICON.UP}
      </div>
    )
  };

  const expandable = config.expandable && {
    expandedRowRender: (record) => (config.expandable(record)),
    rowExpandable: (record) => record.name !== 'Not Expandable',
    expandIcon: ({ expanded, onExpand, record }) => (
      <div
        onClick={(e) => onExpand(record, e)}
        style={{ cursor: 'pointer', width: 'max-content', color: '#1890ff' }}
      >
        <span>{expanded ? 'Ocultar' : 'Ver detalle'}</span>
        {expanded ? ICON.DOWN : ICON.UP}
      </div>
    )
  };

  if (config.filter == true) {
    return (
      <>
        <Row>
          <Col xs={24} xl={20} lg={20}>
            {" "}
          </Col>
          <Col xs={24} xl={4} lg={4}>
            <Input
              placeholder="Buscar"
              allowClear
              id="txtFilterGrid"
              value={value}
              onChange={(e) => {
                const currValue = e.target.value;
                setValue(currValue);
              }}
            />
          </Col>
        </Row>
        <br />
        <Table
          tableLayout="auto"
          className="table-head-bv"
          size="small"
          rowClassName={() => "grid-fw-row"}
          components={components}
          columns={CreateColumn(config, getApi)}
          dataSource={filterData(value)}
          hasData={getApi().getDataContainer().hasData()}
          loading={state.loading}
          expandable={config.expandable && {
            expandedRowRender: (record) => (config.expandable(record)),
            rowExpandable: (record) => record.name !== 'Not Expandable',
          }}
          pagination={{
            ...state.pagination,
            showSizeChanger: config.pagination?.showSizeChanger,
          }}
          onChange={handleTableChange}
          scroll={config.scroll || { x: "max-content" }}
          locale={{ emptyText: "No hay datos" }}
          onRow={(record, rowIndex) => {
            config["api"] = getApi;
            return {
              record,
              config,
              onClick: (event) => {
                log.debug(`GridFw[${name}].rowClick[${record?.key}]`, event);
              },
            };
          }}
          onHeaderRow={(columns, index) => {
            return {
              onClick: () => {}, // click header row
            };
          }}
          rowSelection={getApi().createRowSelection()}
          // rowSelection={{
          //     type: config.selection,
          //     ...rowSelection,
          // }}
        />
      </>
    );
  } else {
    return (
      <>
        <Table
          className="table-head-bv"
          size="small"
          rowClassName={() => "grid-fw-row"}
          components={components}
          columns={CreateColumn(config, getApi)}
          //dataSource={getApi().getDataContainer().getData()}
          dataSource={state.dataList}
          hasData={getApi().getDataContainer().hasData()}
          loading={state.loading}
          expandable={
            config.expandableAsync
              ? expandableAsync
              : config.expandable
              ? expandable
              : undefined
          }
          pagination={{
            ...state.pagination,
            showSizeChanger: config.pagination?.showSizeChanger,
          }}
          onChange={handleTableChange}
          scroll={config.scroll || { x: "fixed" }} //{config.scroll}//fixed//scroll//{x: 'max-content'}
          locale={{ emptyText: "No hay datos" }}
          onRow={(record, rowIndex) => {
            config["api"] = getApi;
            return {
              record,
              config,
              onClick: (event) => {
                log.debug(`GridFw[${name}].rowClick[${record?.key}]`, event);
              },
              //onDoubleClick: event => { console.log('onDoubleClick'); }, // double click row
              //onContextMenu: event => { console.log('onContextMenu'); }, // right button click row
              //onMouseEnter: event => { console.log('onMouseEnter'); }, // mouse enter row
              //onMouseLeave: event => { console.log('onMouseLeave'); }, // mouse leave row
            };
          }}
          onHeaderRow={(columns, index) => {
            return {
              onClick: () => {}, // click header row
            };
          }}
          rowSelection={getApi().createRowSelection()}
          //filterMultiple={true}
        />
      </>
    );
  }
};

const GridFw = ({ name, getParentApi, config }) => {
  log.debug(`GridFw[${name}] => Iniciando`);
  const apiRef = React.useRef(null);
  if (!apiRef.current) {
    apiRef.current = new GridApi(name, null, config, null);
  }
  const [, forceRender] = React.useState(false);
  const getApi = () => apiRef.current;
  const { pagination } = config;
  const [state, setState] = React.useState({
    loading: false,
    pagination: !pagination
      ? false
      : {
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: pagination.showSizeChanger,
        },
  });
  getApi().state = state;
  getApi().setState = setState;
  getApi().forceRender = forceRender;

  const handleTableChange = (toPage, filter, sorter) => {
    if (pagination) {
      if (pagination.server) {
        getApi().load(filter, sorter, toPage);
      } else {
        setState({
          ...state,
          pagination: toPage,
        });
      }
    }
  };

  React.useEffect(() => {
    log.debug(`GridFw[${name}] => Mounting`);

    if (!config.initializedConfig) {
      if (config.autoLoad) getApi().load();
      if (getParentApi) getParentApi().addComponent(name, getApi());
      apiRef.current = new GridApi(name, null, config, null);
    } else {
      if (config.autoLoad) getApi().load();
      if (getParentApi) getParentApi().addComponent(name, getApi());
    }

    return () => {
      log.debug(`GridFw[${name}] => Unmounting`);
    };
  }, [config]);

  if (config?.customTitle) {
    config.title = config.customTitle(getApi().dataContainer.getData())
  }

  //debugger;
  return (
    <ContainerFw childName={name} getParentApi={getApi} config={config}>
      {CreateGrid(name, config, state, handleTableChange, getApi)}
    </ContainerFw>
  );
};
export default GridFw;
